import React from "react";
import masterData from "../../lib/masterData";
import { transportationString } from "../../lib/masterUtil";
import { Link } from "../../lib/Link";

export class Transportation extends React.Component {
  render() {
    return (
      <div className={this.props.className}>
        {this.props.stationInfos &&
          this.props.stationInfos.map((stationInfo, stationInfoIndex) => {
            const station = masterData.station.byId[stationInfo.station];
            return (
              station &&
              (stationInfoIndex == 0 || !this.props.single) && (
                <Link
                  className={this.props.itemClassName || "transportation"}
                  key={stationInfoIndex}
                  to={`/line-${stationInfo.lineSlug}/`}
                >
                  <span className="stationText">
                    {transportationString(stationInfo)}
                  </span>
                </Link>
              )
            );
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/Transportation.jsx